import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type CustomiseMobileActionsClasses = 'actionButtonsContainer';

const customiseMobileActionsStyles = makeStyles<ISpcTheme, CustomiseMobileActionsClasses>(
  theme => ({
    actionButtonsContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        marginTop: '48px',
      },
    },
  }),
  { name: 'Customise_CustomiseMobileActions' },
);

export default customiseMobileActionsStyles;
